export default "__VITE_ASSET__DjHPjrWx__"